import { Button, Modal } from '@hub/shared'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import './modal-update-configuration.component.scoped.scss'
import './modal-update-configuration.component.scss'

export default ({ onClose }: { onClose?: () => any }) => {
  const [t] = useTranslation('modalUpdateConfiguration')
  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false)

  const handleClick = (event: any) => {
    navigate('/profile/notifications')
    setOpenModal(false)
  }

  const onCloseHandle = () => {
    setOpenModal(false)
    if (onClose && typeof onClose === 'function') {
      onClose()
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setOpenModal(true)
    }, 2000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Modal
      forceMobileNoMargin
      modalSize="sm"
      className="modal-update-configuration"
      open={openModal}
      onCloseChange={() => onCloseHandle()}
      header={
        <div className="modal-update-configuration-title">
          <h5>{t('title')}</h5>
        </div>
      }
      footer={
        <div className="modal-update-configuration-footer">
          <Button
            onClick={(e) => handleClick(e)}
            color="var(--primary_color)"
            borderColor="var(--primary_color)"
            textColor="var(--secondary_color)"
            size="sm"
          >
            {t('button')}
          </Button>
        </div>
      }
    >
      <div className="modal-update-configuration-middle">
        <div className="modal-update-configuration-image">
          <i className="mr-1 fa-2xl fa-solid fa-bell yellow"></i>
        </div>
        <div className="modal-update-configuration-text">
          <h6 className="subtitle" dangerouslySetInnerHTML={{ __html: t('subtitle') }} />
          <p dangerouslySetInnerHTML={{ __html: t('text') }} />
        </div>
      </div>
    </Modal>
  )
}
